export default __webpack_public_path__ + "static/media/sh.d83903e2.png";